import React from "react";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ToursSection from "./components/ToursSection";
import TransfersSection from "./components/TransfersSection";
import AreasSection from "./components/AreasSection";
import TestimonialsSection from "./components/TestimonialsSection";
import GallerySection from "./components/GallerySection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <main>
          <HeroSection />
          <ServicesSection />
          <ToursSection />
          <TransfersSection />
          <AreasSection />
          <TestimonialsSection />
          <GallerySection />
          <FAQSection />
          <ContactSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;